module.exports = __webpack_public_path__ + "img/IMG_2729_L_Black.0d0f4e87.jpg";